import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Allroutes from "./routes";
import ScrollToTop from "./utils/ScrollToTop";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";

const CanonicalURLUpdater = () => {
  const location = useLocation();
  
  useEffect(() => {
    const updateCanonicalUrl = () => {
      const cleanUrl = window.location.origin + location.pathname;

      let canonicalLink = document.querySelector('link[rel="canonical"]');
      if (!canonicalLink) {
        canonicalLink = document.createElement('link');
        canonicalLink.rel = 'canonical';
        document.head.appendChild(canonicalLink);
      }
      canonicalLink.href = cleanUrl;
    };
    
    updateCanonicalUrl();
  }, [location.pathname]);
  
  return null;
};

const App = () => {
  return (
    <>
      <CanonicalURLUpdater />
      <ScrollToTop />
      <Allroutes />
       {/* <GoogleReCaptchaProvider /> */}
    </>
  );
};

export default App;